/**
 * A single entry in the cache.
 *
 * @property {Number} createdOn Timestamp of when the item was created.
 * @property {Number} expiresOn Timestamp of when the item is to expire.
 * @property {String} type      Item type slug
 * @property {*} id             Unique ID of the item
 * @property {*} value          The item's value
 */
class HttpCacheItem {
  constructor(createdOn, expiresOn, type, id, value) {
    this.createdOn = createdOn
    this.expiresOn = expiresOn
    this.type = type
    this.id = id
    this.value = value
  }
}

export default HttpCacheItem
